import axios, {AxiosRequestConfig, AxiosResponse} from 'axios';

// Defining global types for environment variables
const API_URL: string = process.env.REACT_APP_ENDPOINT + "/";
const USER: string = process.env.REACT_APP_AUTH_API_USER!;
const PASSWORD: string = process.env.REACT_APP_AUTH_API_PASSWORD!;

// Define Request Methods
type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

// Define apiV3 function type
interface ApiV3 {
    (endpoint: string, method?: HttpMethod, data?: Record<string, any> | null, contentType?: string): Promise<AxiosResponse>;

    get: (endpoint: string) => Promise<AxiosResponse>;
    post: (endpoint: string, data: Record<string, any>) => Promise<AxiosResponse>;
    put: (endpoint: string, data: Record<string, any>) => Promise<AxiosResponse>;
    delete: (endpoint: string) => Promise<AxiosResponse>;
    postEncoded: (endpoint: string, data: Record<string, any>) => Promise<AxiosResponse>;
}

const apiV3: ApiV3 = async (
    endpoint: string,
    method: HttpMethod = 'GET',
    data: Record<string, any> | null = null,
    contentType: string = 'application/json'
): Promise<AxiosResponse> => {
    const api_credentials: string = btoa(`${USER}:${PASSWORD}`);
    const access_token: string | null = sessionStorage.getItem('@auth_token');

    try {
        // Optional ping (seems like health check, though not returning anything in this code)
        await fetch(API_URL, {
            method: 'GET',
            headers: {
                'Authorization': `Basic ${api_credentials}`,
                'Content-Type': 'application/json',
                'x-auth-token': access_token || '',
            },
        });

        // Axios request configuration
        const config: AxiosRequestConfig = {
            method,
            url: `${API_URL}${endpoint}`,
            headers: {
                'Authorization': `Basic ${api_credentials}`,
                'Content-Type': contentType,
                'x-auth-token': access_token || '',
            },
            data: contentType === 'application/x-www-form-urlencoded'
                ? new URLSearchParams(data || {}).toString()
                : data,
        };

        // Return the axios response
        return await axios(config);
    } catch (err: unknown) {
        console.error('apiV3 request error:', err);
        throw err;
    }
};

// Adding helper methods with improved types
apiV3.get = (endpoint: string) => apiV3(endpoint, 'GET');
apiV3.post = (endpoint: string, data: Record<string, any>) => apiV3(endpoint, 'POST', data);
apiV3.put = (endpoint: string, data: Record<string, any>) => apiV3(endpoint, 'PUT', data);
apiV3.delete = (endpoint: string) => apiV3(endpoint, 'DELETE');
apiV3.postEncoded = (endpoint: string, data: Record<string, any>) =>
    apiV3(endpoint, 'POST', data, 'application/x-www-form-urlencoded');

export default apiV3;
